import { render, staticRenderFns } from "./PrivacyListComponent.vue?vue&type=template&id=bc093fe0"
import script from "./PrivacyListComponent.vue?vue&type=script&lang=js"
export * from "./PrivacyListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports